'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var type = require('./type.js');

const getMaxValue = (value, total, type$1) => {
  let maxValue = total;
  if (type$1 === type.NumberType.percent) {
    maxValue = 100;
  }
  return Math.max(value, maxValue);
};
const calculatePercent = (value, maxValue) => {
  return Math.min(100, Math.round(value / maxValue * 1e4) / 1e4 * 100);
};

exports.calculatePercent = calculatePercent;
exports.getMaxValue = getMaxValue;
